<template>
  <div class="UIPack">
    <div class="container" style="min-height: calc(100vh - 40px);">
        <div style="margin-top:10vh;"></div>
        <div class="ui-card ui-white ui-shadow">
            <a>
            <img class="uipack-img" src="/images/side/uipack_sea.jpg" alt="UIPack Sea">
            </a>
            <div class="ui-content">
                <div class="ui-title">UIPack Sea</div>
                <div class="ui-description">{{ $t('uipack_sea_description')}}</div>
            </div>
        </div>
        <div class="ui-card ui-white ui-shadow" onclick="window.open('/classic/')">
        <img v-lazy="$t('uipack_classic_side_img')" alt="UIPack Classic" style="width:100%;">
        <div class="ui-content">
            <div class="ui-title">UIPack Classic</div>
            <div class="ui-description">{{ $t('uipack_classic_description')}}</div>
        </div>
        </div>

        <div style="margin:50px 0;">
            <router-link to="/downloads" class="head-box-btn ui-big ui-no-border ui-purple-gradients" style="padding:0.438em">
                {{ $t('download')}}
            </router-link>
        </div>
        <div class="text-center">
        </div>
        <div style="height:1em;"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloI18n from '@/components/HelloI18n.vue'

export default {
  name: 'home'
}
</script>